module.exports = __webpack_public_path__ + "static/media/step1-select.eb7b15a6.svg";